import { Button, Spin } from "antd";
import { motion } from "framer-motion";
import { Props } from "@/models";
import { useApiStore } from "@/store";
import { useAPI } from "@/hooks";

export const AppButton = ({
  name,
  onClick,
  htmlType,
  block,
  classNames,
  loading,
  disabled,
  callApi,
  customApiConfigs,
}: Props.Button) => {
  const api = useApiStore((state) => state);
  const { callGetData, callPostData } = useAPI();

  const executeOnlick = async () => {
    if (onClick && !callApi) {
      onClick();
    } else if (onClick && callApi) {
      if (customApiConfigs?.method === "GET") {
        callGetData(
          customApiConfigs.endpoint as string,
          customApiConfigs.callBackFunction
        );
      } else if (customApiConfigs?.method === "POST") {
        callPostData({
          url: customApiConfigs.endpoint as string,
          customRequest: customApiConfigs.customPayload,
          callBackApiResponse: customApiConfigs.callBackFunction,
        });
      }
    }
  };
  return (
    <>
      {htmlType === "link" ? (
        api.isProcessing ? (
          <>
            <Spin size="small" className="ml-2" />
          </>
        ) : (
          <a className={classNames} onClick={executeOnlick}>
            {name}
          </a>
        )
      ) : (
        <motion.div whileHover={{ scale: 1.0 }} whileTap={{ scale: 0.95 }}>
          <Button
            type="primary"
            htmlType={htmlType === "submit" ? "submit" : "button"}
            disabled={disabled || (htmlType === "submit" && !api.submitForm)}
            className={`bg-[#6f0037] border-[#006F01] disabled:bg-[#E5E7E8] disabled:hover:scale-100 disabled:hover:border-[#E5E7E8] 
            disabled:hover:bg-[#E5E7E8!important] disabled:hover:text-[#ffffff!important] text-[#ffffff!important] hover:scale-105 
            transition-all flex items-center justify-center py-6  ${classNames}`}
            block={block}
            onClick={executeOnlick}
            loading={loading || api.isProcessing}
          >
            {name}
          </Button>
        </motion.div>
      )}
    </>
  );
};

export const SubmitButton: React.FC<Props.SubmitButton> = ({
  name,
  classNames,
  form,
  loading,
  customApiConfigs,
}) => {
  const api = useApiStore((state) => state);
  return (
    <AppButton
      name={name}
      block={true}
      htmlType="submit"
      classNames={classNames}
      form={form}
      loading={loading || api.isProcessing}
      customApiConfigs={customApiConfigs}
    />
  );
};

export const Link: React.FC<Props.SubmitButton> = ({
  name,
  classNames,
  form,
  loading,
  callApi,
  onClick,
  customApiConfigs,
}) => {
  const api = useApiStore((state) => state);
  return (
    <AppButton
      name={name}
      block={true}
      htmlType="link"
      onClick={onClick}
      callApi={callApi}
      classNames={classNames}
      form={form}
      loading={loading || api.isProcessing}
      customApiConfigs={customApiConfigs}
    />
  );
};

export const Primary: React.FC<Props.SubmitButton> = ({
  name,
  classNames,
  loading,
  onClick,
}) => {
  return (
    <motion.div whileHover={{ scale: 1.0 }} whileTap={{ scale: 0.95 }}>
      <Button
        htmlType="button"
        className={`${classNames} bg-[#6f0037] border-[#006F01] disabled:bg-[#E5E7E8] disabled:hover:scale-100 disabled:hover:border-[#E5E7E8] 
    disabled:hover:bg-[#E5E7E8!important] disabled:hover:text-[#ffffff!important] text-[#ffffff!important] hover:scale-105 
    transition-all flex items-center justify-center py-6`}
        onClick={onClick}
        loading={loading}
      >
        {name}
      </Button>
    </motion.div>
  );
};

AppButton.Submit = SubmitButton;
AppButton.Link = Link;
